import { IApiSuccessWrapper, IOperator } from '$/types'
import { apiSlice } from '.'

export interface IGetSystemScopeOperatorsParams {
  regionCodes?: string[]
  stateCodes?: string[]
}

export const systemScopeOperatorsApi = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getOperators: build.query<IOperator[], IGetSystemScopeOperatorsParams>({
      query: ({ regionCodes, stateCodes }) => ({
        method: 'GET',
        url: '/operators',
        params: {
          // Only include parameters in query string if provided
          ...(regionCodes != null &&
            regionCodes.length > 0 && { regionCode: regionCodes }),
          ...(stateCodes != null &&
            stateCodes.length > 0 && { stateCode: stateCodes })
        }
      }),
      transformResponse: (res: IApiSuccessWrapper) => {
        return res.result as IOperator[]
      }
    })
  })
})

export const { useGetOperatorsQuery } = systemScopeOperatorsApi
